import { ref } from "@vue/composition-api";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { EventPost } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import usePaymentPackage from "@/hooks/usePaymentPackage";
import providers from "@/lib/api";

export default function useEvents() {
  const eventData = ref<EventPost | null>(null);
  const paymentPackages = ref<PaymentPackage[]>([]);
  const contentFeed = ref<ContentFeed | null>(null);

  const getEventPost = async (eventId: string) => {
    const response = await providers.EventPostProvider.find({ postIds: [eventId] });
    eventData.value = response.find(event => event.postId === eventId) || null;
  };

  const { findAll: findAllPaymentPackages } = usePaymentPackage();
  const getPaymentPackages = async () => {
    paymentPackages.value = await findAllPaymentPackages([PaymentPackageEnum.FILESET]);
  };
  const getContentFeed = async () => {
    const response = await providers.ContentFeedProvider.search({
      data: {
        userId: eventData.value?.userId ?? "",
        ids: [eventData.value?.postId ?? ""],
        size: 1,
        includeScheduled: false,
        published: true,
      },
    });
    contentFeed.value = response.result.find(content => content.id === eventData.value?.postId) ?? null;
  };

  const getEventsData = async (eventId: string) => {
    await getEventPost(eventId);
    await getPaymentPackages();
    await getContentFeed();
  };

  return {
    eventData,
    contentFeed,
    paymentPackages,
    getEventsData,
  };
}
